import { t } from '@lingui/macro';
import { Info } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger } from 'components/ui/tooltip';

/**
 * Info icon with themed tooltip (Radix). Requires {@link TooltipProvider} above in the tree.
 */
export default function InfoTooltip(props) {
    const { message } = props;

    return (
        <Tooltip delayDuration={200}>
            <TooltipTrigger asChild>
                <button
                    type="button"
                    className="inline-flex h-6 w-6 shrink-0 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent p-0 shadow-none [background-image:none] text-muted-foreground transition-colors hover:bg-white/5 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                    aria-label={t`More information`}
                >
                    <Info className="h-[18px] w-[18px]" strokeWidth={2} aria-hidden />
                </button>
            </TooltipTrigger>
            <TooltipContent
                side="top"
                sideOffset={6}
                className="border-primary/25 bg-primary text-primary-foreground shadow-md"
            >
                {message}
            </TooltipContent>
        </Tooltip>
    );
}
